export enum VocabularyTypeEnum {
  Grade = 1,
  Toefl = 2,
  Unite = 3,
}
